export default function () {
  return {
    cuentaBanco: null,  
  };
}
